export const OnCallUserIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
    <path
      d="M4.25 0.130859V2.63086H11.75V0.130859H13V2.63086C14.3807 2.63086 15.5 3.75015 15.5 5.13086V15.1309C15.5 16.5116 14.3807 17.6309 13 17.6309H3C1.61929 17.6309 0.5 16.5116 0.5 15.1309V5.13086C0.5 3.75015 1.61929 2.63086 3 2.63086V0.130859H4.25ZM14.25 7.63086H1.75V15.1309C1.75 15.7719 2.23255 16.3002 2.85422 16.3724L3 16.3809H13C13.641 16.3809 14.1694 15.8983 14.2416 15.2766L14.25 15.1309V7.63086ZM6.75 8.88086V12.6309H3V8.88086H6.75Z"
      fill="#09305A"
    />
  </svg>
);
